module.exports = __webpack_public_path__ + "static/media/tendericon02@2x.34f56446.png";